import * as $ from 'jquery';

import './../css/reset.css';
import './../css/font.css';
import './../css/style.scss';
import { showHalalConsent } from './halal-consent';

////////////////////////////////////////////////////
// Error Messages //////////////////////////////////
////////////////////////////////////////////////////

function showMessage() {
  $('body').css('min-height', '527px');
  // $('#index #container, #helpText').css('margin-top', '-100px');
  $('#errMessage').show();
}

function hideMessage() {
  $('body').css('min-height', '470px');
  // $('#index #container, #helpText').css('margin-top', '-124px');
  $('#errMessage').hide();
}

$(document).ready(function () {
  var langCode = $('body').attr('data-lang');

  ////////////////////////////////////////////////////
  // Error Message ///////////////////////////////////
  ////////////////////////////////////////////////////

  if ($('#errMessage .content').text() != '') {
    showMessage();
  }

  ////////////////////////////////////////////////////
  // Halal Consent ///////////////////////////////////
  ////////////////////////////////////////////////////

  showHalalConsent();

  ////////////////////////////////////////////////////
  // Index ///////////////////////////////////////////
  ////////////////////////////////////////////////////

  $('#choose').click(function (event) {
    hideMessage();

    $('#buttons').hide(0);

    $('#enterEmail').show(0, function () {
      $('#enterEmail input').val('').focus();
    });
  });

  $('#choose-form').on('submit', function (event) {
    if ($('#enterDomain:hidden').length) {
      $('#next').trigger('click');
      event.preventDefault();
      return false;
    }
  });

  $('#next').click(function (event) {
    var name = $('#enterEmail input').val();

    // The name filed is empty
    if (name === '') {
      return false;
    }

    $('#enterDomain select option').prop('selected', false);
    $('#enterDomain select option:eq(0)').prop('selected', true);

    $('#enterDomain select option').each(function (index, elem) {
      elem = $(elem);
      elem.text(name + '@' + elem.attr('value'));
    });

    $('#enterEmail').hide(0, function () {
      $('#enterDomain').show(0, function () {
        $('#enterDomain select').focus();
      });
    });
  });

  $('#create').click(function (event) {
    $('form').submit();
  });

  ////////////////////////////////////////////////////
  // Index > Languages ///////////////////////////////
  ////////////////////////////////////////////////////

  $('#langaugesMenu').on('click', function () {
    $(this).toggleClass('active');
  });

  ////////////////////////////////////////////////////
  // Index > Help ////////////////////////////////////
  ////////////////////////////////////////////////////

  $('#help h2').hover(
    function () {
      var index = $(this).index();
      $('#index #container').addClass('hidden');
      $('#helpText div').eq(index).removeClass('hidden');
      $('#helpText').removeClass('hidden');
    },
    function () {
      var index = $(this).index();
      $('#index #container').removeClass('hidden');
      $('#helpText div').eq(index).addClass('hidden');
      $('#helpText').addClass('hidden');
    }
  );

  ////////////////////////////////////////////////////
  // Inbox ///////////////////////////////////////////
  ////////////////////////////////////////////////////

  if ($('#inbox').length) {
    import(/* webpackChunkName: "inbox" */ './inbox').then(function ({ initInbox }) {
      initInbox(langCode);
    });
  }
});
